module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_remer",
    attrs: {
      "epub:type": "acknowledgments",
      "role": "doc-acknowledgments"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_IX",
      "role": "doc-pagebreak",
      "title": "IX"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "fig-014",
      "src": "images/spectrum_bar_gray.jpg"
    }
  })])]), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_c('b', [_vm._v("We would like to thank")])]), _vm._v(" each contributor—Michael Horton, Steve Wellum, Darrell Bock, and Mark Snoeberger—for their thoughtful and provocative essays and for the collegial and irenic spirit that is represented in their response essays. Working with each contributor was a joy, not least in their timely responses to inquiries and suggested revisions. They were easy to collaborate with. Moreover, there were some unfortunate delays during the course of the project, and the contributors were very patient throughout as these circumstances were resolved. We are convinced that the quality of these contributors and the essays that they wrote will make this book a standard resource on the topic for many years to come.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We would also like to thank our IVP editor, Dan Reid, who initiated this project with us before his retirement, and we also extend our gratitude to David McNutt, who stepped in after Dan and assisted in bringing this project to completion. David made helpful observations and suggestions and was instrumental in guiding us along.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I (Brent) would like to thank my wife Kandace for her love, encouragement, and support during the long process of working on this project. Our four young children (Evan, William, Andrew, and Annette) have much energy, and she kept them busy at times so I could focus my efforts to this work. Kandace and the children are sweet reminders of God’s favor and blessing in my life.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the end of several years of working to get this book published, I (Richard) would like to express loving appreciation to my family. My wife Tina has not only been supportive and encouraging for me to pursue this project but she has been a dialogue partner about the subject matter as we "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_X",
      "role": "doc-pagebreak",
      "title": "X"
    }
  }, [_vm._v("have traveled this theological journey together over the years. Our four children are excited about dad’s book coming out, even though they would have rather we had chosen a more kid-friendly title!")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0